var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('create-credentials',{attrs:{"submit-button-text":"Cambiar Contraseña","action":"reset"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }